import { ReactElement } from "react";

import { useSelector } from "react-redux";
import {
  AddressCompleteSearchProvider,
  AddressFieldWithLoqateConfig,
  CountryFieldConfig,
} from "@evergiving/common/dist/es2015/form";

import { RootState } from "@/lib/redux/types";
import { PostalAddressKind } from "@evergiving/common/dist/es2015/pledge";
import { SearchAddressField } from "@/lib/components/SearchAddressField";
import { SearchAddressWithProviderField } from "@/lib/components/SearchAddressWithProviderField";
import { FreeFormAddressComponent } from "@/lib/components/FreeFormAddressComponent";

import { useAddressFieldWithSearch } from "../hooks/useAddressFieldWithSearch";

export function AddressFieldWithLoqateSearch({
  locale,
  countryFieldConfig,
  addressFieldConfig,
  defaultCountryCode,
}: {
  locale: string;
  countryFieldConfig: CountryFieldConfig | undefined;
  addressFieldConfig: AddressFieldWithLoqateConfig;
  defaultCountryCode: string;
}): ReactElement | null {
  const postalAddress = useSelector((state: RootState) => state.postalAddress);

  const searchUrl = new URL(
    addressFieldConfig.loqate.addressCompletionEndpointUrl
  );

  const {
    handleChange,
    handleSearch,
    handleClear,
    countryName,
    freeFormAddressFieldConfig,
    results,
    loading,
    text,
  } = useAddressFieldWithSearch({
    searchUrl,
    searchProvider: AddressCompleteSearchProvider.Loqate,
    countryFieldConfig,
    addressFieldWithoutSearch: addressFieldConfig,
  });

  if (postalAddress === undefined) {
    return (
      <SearchAddressField
        locale={locale}
        addressFieldConfig={addressFieldConfig}
        results={results}
        onChange={handleChange}
        onSearch={handleSearch}
        onClear={handleClear}
        loading={loading}
        value={text}
        defaultCountryCode={defaultCountryCode}
      />
    );
  }

  if (postalAddress.kind === PostalAddressKind.Loqate) {
    const addressLine = postalAddress.Text;
    return (
      <SearchAddressWithProviderField
        addressLine={
          countryName ? `${addressLine} ${countryName}` : addressLine
        }
        searchAddressProviderFieldConfig={addressFieldConfig.loqate}
      />
    );
  }

  return (
    <FreeFormAddressComponent
      freeFormAddressFieldConfig={freeFormAddressFieldConfig}
    />
  );
}
